import { patch, get, putFile, put } from './index';

export const getBookingBySecret = ({ secret }) => {
  if (!secret) {
    return Promise.resolve(null);
  }
  return get(`/hotelKeeperBooking/${secret}`);
};

export const quickUpdateBooking = ({ secret, body }) => {
  return patch(`/hotelKeeperBooking/${secret}/quickModification`, body);
};

export const updateHotelKeeperBookingState = ({ secret, body }) => {
  return patch(`/hotelKeeperBooking/${secret}/state`, body);
};

export const getBookingMessageBySecret = ({ secret }) => {
  if (!secret) {
    return Promise.resolve(null);
  }
  return get(`/hotelKeeperBooking/${secret}/messages`);
};

export const getBookingDocumentsBySecret = ({ secret }) => {
  if (!secret) {
    return Promise.resolve(null);
  }
  return get(`/hotelKeeperBooking/${secret}/documents`);
};

export const createHotelKeeperBookingDocument = ({ secret, data }) =>
  putFile(`/hotelKeeperBooking/${secret}/documents`, data);

export const createHotelKeeperBookingMessage = ({ secret, data }) =>
  put(`/hotelKeeperBooking/${secret}/messages`, data);

export const getBookingDocumentBySecret = ({
  secret,
  bookingId,
  documentId,
}) => {
  if (!secret) {
    return Promise.resolve(null);
  }
  return get(
    `/hotelKeeperBooking/${secret}/booking/${bookingId}/documents/${documentId}`,
    { responseType: 'blob' },
    false,
  );
};
